<ng-container *transloco="let tSettings; read: 'status_configuration'">
    <div class="drag-container">
        <div class="flex items-center gap-1">
            <span>{{ tSettings('active_statuses') }}</span>
            <app-tb-tooltip-component class="icon-sm" [tooltip]="'This is active statuses'">
                <app-tb-icon icon="info" color="textLight"></app-tb-icon>
            </app-tb-tooltip-component>
        </div>
        <div>
            @for (
                option of optionsByTags.active;
                track trackByOption($index, option);
                let index = $index
            ) {
                <app-select-option
                    appTbDropContainer
                    appTbDrag
                    [data]="getOptionDragData(option, optionTags.ACTIVE, index)"
                    orientation="vertical"
                    (droppedContainer)="drop($event)"
                    [field]="field"
                    [option]="option"
                    [dragData]="getOptionDragData(option, optionTags.ACTIVE, index)"
                    [dragDisabled]="optionsByTags.active.length === 1"
                    [optionGroup]="getOptionGroup(option.guid!)"
                    [template]="template"
                    [isDefault]="option.guid === defaultOption.guid"
                    (defaultChange)="defaultChange(option.guid!)"
                    (delete)="delete(option.guid!, optionTags.ACTIVE)"
                ></app-select-option>
            }
        </div>
        <app-tb-button
            appearance="text"
            icon="add_circle_outline"
            (click)="add(optionTags.ACTIVE)"
            >{{ tSettings('add_status') }}</app-tb-button
        >

        <div class="flex items-center gap-1">
            <span>{{ tSettings('done_statuses') }}</span>
            <app-tb-tooltip-component class="icon-sm" [tooltip]="'This is done statuses'">
                <app-tb-icon icon="info" color="textLight"></app-tb-icon>
            </app-tb-tooltip-component>
        </div>
        <div>
            @for (
                option of optionsByTags.done;
                track trackByOption($index, option);
                let index = $index
            ) {
                <app-select-option
                    appTbDropContainer
                    appTbDrag
                    orientation="vertical"
                    [data]="getOptionDragData(option, optionTags.DONE, index)"
                    [field]="field"
                    [option]="option"
                    [dragData]="getOptionDragData(option, optionTags.DONE, index)"
                    [optionGroup]="getOptionGroup(option.guid!)"
                    [template]="template"
                    [isDefault]="option.guid === defaultOption.guid"
                    [dragDisabled]="optionsByTags.done.length === 1"
                    (droppedContainer)="drop($event)"
                    (defaultChange)="defaultChange(option.guid!)"
                    (delete)="delete(option.guid!, optionTags.DONE)"
                ></app-select-option>
            }
        </div>
        <app-tb-button appearance="text" icon="add_circle_outline" (click)="add(optionTags.DONE)">{{
            tSettings('add_status')
        }}</app-tb-button>
    </div>

    <div class="closed-options">
        <div class="flex items-center gap-1">
            <span>{{ tSettings('closed_statuses') }}</span>
            <app-tb-tooltip-component class="icon-sm" [tooltip]="'This is closed statuses'">
                <app-tb-icon icon="info" color="textLight"></app-tb-icon>
            </app-tb-tooltip-component>
        </div>
        @for (
            option of optionsByTags.close;
            track trackByOption($index, option);
            let index = $index
        ) {
            <app-select-option
                appTbDrag
                [field]="field"
                [option]="option"
                [dragData]="getOptionDragData(option, optionTags.CLOSE, index)"
                [dragDisabled]="true"
                [optionGroup]="getOptionGroup(option.guid!)"
                [template]="template"
                [isDefault]="option.guid === defaultOption.guid"
                (delete)="delete(option.guid!, optionTags.CLOSE)"
            ></app-select-option>
        }
    </div>
</ng-container>
